import { Badge, Box, type BoxProps } from "@chakra-ui/react";
import { type ReactNode } from "react";

interface SelectableCardProps extends Omit<BoxProps, "children"> {
  isSelected: boolean;
  isDisabled?: boolean;
  disabledLabel?: string;
  children: ReactNode;
}

export const SelectableCard = ({
  isSelected,
  isDisabled = false,
  disabledLabel,
  children,
  ...boxProps
}: SelectableCardProps) => (
  <Box
    as="button"
    borderWidth="2px"
    borderRadius="lg"
    borderColor={isSelected ? "smPrimarySoft" : "smBorder"}
    bg={isDisabled ? "smBackgroundSecondary" : isSelected ? "smPrimarySofter" : "smBackground"}
    p="4"
    pr={isDisabled && disabledLabel ? "24" : "4"}
    textAlign="left"
    transition="all 0.15s ease"
    opacity={isDisabled ? 0.6 : 1}
    cursor={isDisabled ? "not-allowed" : "pointer"}
    _hover={!isDisabled ? { borderColor: "smPrimarySoft", shadow: "sm" } : {}}
    position="relative"
    {...boxProps}
  >
    {isDisabled && disabledLabel && (
      <Badge
        colorScheme="gray"
        fontSize="2xs"
        variant="subtle"
        position="absolute"
        top="3"
        right="3"
      >
        {disabledLabel}
      </Badge>
    )}
    {children}
  </Box>
);
